interface TextSectionBlockProps {
  content: {
    title?: string;
    body?: string;
    showDivider?: boolean;
  };
}

export function TextSectionBlock({ content }: TextSectionBlockProps) {
  return (
    <section className="mx-auto max-w-[1200px] px-6 py-16">
      {content.showDivider && (
        <div className="mb-12 h-px w-16 bg-border" />
      )}
      {content.title && (
        <h2 className="font-serif text-2xl md:text-3xl text-foreground mb-6">
          {content.title}
        </h2>
      )}
      {content.body && (
        <div className="max-w-[800px] font-sans text-base leading-relaxed text-muted-foreground whitespace-pre-line">
          {content.body}
        </div>
      )}
    </section>
  );
}
